module.exports = __webpack_public_path__ + "static/img/ourselves2.76e137d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ourselves2.jpg
// module id = fOuJ
// module chunks = 0